import Phaser, { Scene } from 'phaser'

import MapComponent from './map'
import MinimapComponent from './minimap'
import ViewportComponent from './viewport'
import DragElementComponent from './drag-element'
import ToolBoxComponent from './tool-box'
import LoadingComponent from './loading'
import Timer from './timer'
import Points from './points'
import BtnEndGame from './btn-endgame'
import { TIMER_DEFAULT_VALUES, CUSTOM_FONTS, MELODYS, pillBgImage } from './../constants/game'

import { TimerData } from './../utils/TimerData'
import BtnFullScreen from './btn-fullscreen'
import WinPointsMessageComponent from './win-points-message'
import BtnMelody from './btn-melody'
import Cursor from './cursor'
import IntroText from "./intro-text";

export default class SceneTemplate extends Scene {
  /** @type {MapComponent} */
  cMap
  /** @type {MinimapComponent} */
  cMinimap
  /** @type {ViewportComponent} */
  cViewport
  /** @type {DragElementComponent} */
  cDragElement

  lifecycle = []

  WORD_LIST
  BACKGROUND_CONTEXT
  onStartCallback
  /** @type {String} */
  roomName
  constructor(KEY, WORD_LIST, BACKGROUND_CONTEXT, onStartCallback) {
    super({
      key: KEY,
      type: Phaser.AUTO,
      physics: {
        default: 'arcade',
        arcade: {
          gravity: {},
          debug: process.env.ENVIRONTMENT !== 'PDN',
        },
      },
    })
    this.KEY = KEY;
    this.WORD_LIST = WORD_LIST
    this.BACKGROUND_CONTEXT = BACKGROUND_CONTEXT
    this.onStartCallback = onStartCallback;
    this.fonts_load = false;
    this.ready = false;
    this.game_ended = false;
    this.roomName = KEY;
  }

  // PREPARE data and default configs
  init(props) {


    // -- window.$scene = this;
    this.cursor = new Cursor(this.game);
    this.backgroundMelody = null;
    this.victoryMelody = null;
    this.HANDLE_END_SCENE = props.handleEndScene
    this.data.set({ ...props, POINTS: 0 })
    this.cMap = new MapComponent(this, this.BACKGROUND_CONTEXT)
    this.lifecycle.push(this.cMap)

    this.cViewport = new ViewportComponent(this, this.cursor)
    this.lifecycle.push(this.cViewport)

    this.cMinimap = new MinimapComponent(this, this.cMap)
    this.lifecycle.push(this.cMinimap)

    this.cToolBox = new ToolBoxComponent(this, this.WORD_LIST, () => {
      this.endgame(true)
    })
    this.lifecycle.push(this.cToolBox)


    this.WORD_LIST.forEach((word, index) => {
      let _cDragElement = new DragElementComponent(this, this.cursor, word, index);
      this.lifecycle.push(_cDragElement)
    }, this)
    this.data.set('WORDS_LENGTH', this.WORD_LIST.length)

    this.cTimer = new Timer(
      this,
      new TimerData({
        frequency: TIMER_DEFAULT_VALUES.frequency,
        incrementFactor: TIMER_DEFAULT_VALUES.incrementFactor,
        initialValue: TIMER_DEFAULT_VALUES.initialValue,
        limitTime: TIMER_DEFAULT_VALUES.limitTime,
        timeOffHandler: () => {
          this.endgame(false)
        },
      })
    )
    this.lifecycle.push(this.cTimer)

    this.cPoints = new Points(this)
    this.lifecycle.push(this.cPoints)

    this.cBtnEndGame = new BtnEndGame(this, () => {
      this.endgame(false)
    })
    this.lifecycle.push(this.cBtnEndGame)
    //

    this.cBtnFullScreen = new BtnFullScreen(this)
    this.lifecycle.push(this.cBtnFullScreen)
    //
    this.cBtnMelody = new BtnMelody(this)
    this.lifecycle.push(this.cBtnMelody)
    //
    this.cWinPointsMessageComponent = new WinPointsMessageComponent(this)
    this.lifecycle.push(this.cWinPointsMessageComponent)
    //
    this.cIntroText = new IntroText(this);
    this.lifecycle.push(this.cIntroText)
    if (this.onStartCallback && typeof (this.onStartCallback) === "function") {
      this.onStartCallback();
    }

    this.data.set('isRunning', false)
  }

  // LOAD assets
  preload() {
    this.load.audio("background-melody", MELODYS.melody_1);
    this.load.audio("victory-sound", MELODYS.victory_sound);
    this.load.audio("second-to-point", MELODYS.seconds_to_points);
    this.load.image("pill-bg", pillBgImage);
    new LoadingComponent(this)
    this.lifecycle.forEach((component) => {

      if (component.preload) component.preload()
    })
  }

  // ADD assets
  create() {
    this.createMelodys();
    this.waitForWebFont().then(() => {
      this.lifecycle.forEach((component) => {
        if (component.create) component.create()
      })
      this.fonts_load = true;
      this.startMelody();
    })
  }
  waitForWebFont() {
    return new Promise((resolve) => {
      if (window.WebFont) {
        window.WebFont.load({
          custom: {
            families: [...CUSTOM_FONTS]
          },
          active: resolve
        });

      } else {
        resolve();
      }
    });
  }

  createMelodys() {
    const addMelody = (path) => {
      const sound = this.sound.add(path);

      sound.setVolume(0)
      sound.volume = 0;
      let busy = false;
      return {
        sound,
        isPlaying: () => sound.isPlaying,
        play: () => {
          sound.setVolume(0)
          sound.play();

          const volume = this.isMuted() ? 0 : MELODYS.volume;
          busy = true;
          this.tweens.add({
            targets: sound,
            volume,
            duration: 3500, onComplete: () => {
              busy = false;
            }
          });
        },
        stop: () => {
          sound.stop();
        },
        fade: () => {
          busy = true;
          this.tweens.add({
            targets: sound,
            volume: 0,
            duration: 1000,
            onComplete: () => {
              busy = false;
              sound.stop();
            }
          });
        },
        update: () => {
          if (busy) {
            return
          }
          if (!sound.isPlaying) {
            return;
          }
          const volume = this.isMuted() ? 0 : MELODYS.volume;
          if (sound.volume === volume) {
            return;
          }

          busy = true;
          this.tweens.add({
            targets: sound,
            volume,
            duration: 500,
            onComplete: () => {
              busy = false;
            }
          });

        }
      }
    }
    const addSFX = (path) => {
      let soundConfig = {
        volume: 1,
      }
      return {
        setConfig: (_newconfig) => {
          soundConfig = { ..._newconfig };
        },
        play: () => { this.sound.play(path, soundConfig); },
      }
    }
    this.backgroundMelody = addMelody('background-melody');
    this.backgroundMelody.sound.loop = true;
    this.victoryMelody = addMelody('victory-sound');
    this.SFX_secondToPoint = addSFX('second-to-point');

  }
  getRoomName() {
    return this.roomName
  }
  isMuted() {
    return this.cBtnMelody.isMuted();
  }
  startMelody() {
    this.backgroundMelody.play();
  }
  melodyUpdate() {
    // UPDATE MELODY VOLUME
    this.backgroundMelody.update();
    this.victoryMelody.update();
  }
  // RELOADS data on frames changes
  update(time, delta) {

    if (!this.fonts_load) {
      return;
    }

    if (!this.data.get('isRunning')) {
      this.data.set('isRunning', true)
      if (sessionStorage.getItem('PHASER_RUNNING') !== 'true') {
        this.scene.pause()
      }
    }

    this.melodyUpdate();

    this.lifecycle.forEach((component) => {
      if (component.upload) component.upload()
      if (component.update) component.update()
    })
  }
  doVictoryMelody() {
    return new Promise((resolve) => {

      this.backgroundMelody.fade();
      this.victoryMelody.play();
      this.victoryMelody.sound.on("complete", resolve);
    })
  }


  sumPointsForSeconds() {
    return new Promise((resolve) => {
      const timeStored = this.data.get('TIME');
      const originalPointsStored = this.data.get('POINTS');

      this.data.set('POINTS', originalPointsStored + timeStored);
      this.SFX_secondToPoint.play();

      setTimeout(resolve, 1000);
    })
  }
  endgame(win) {
    if (this.game_ended) {
      return
    }
    this.game_ended = true;
    const onComplete = () => {
      this.cBtnFullScreen.escFullScreen();
      this.backgroundMelody.stop();
      this.victoryMelody.stop();
      this.scene.pause()
      this.HANDLE_END_SCENE({
        points: this.data.get('POINTS'),
        time: this.data.get('TIME'),
        words_length: this.data.get('WORDS_LENGTH'), win
      });
    }
    if (win) {
      this.cTimer.stop();
      this.doVictoryMelody()
        .then(() => { return this.sumPointsForSeconds() })
        .then(onComplete)
    } else {
      this.scene.pause()
      onComplete();
    }

  }
}
